import React, {useState, useEffect} from 'react';
import {v1 as uuidv1} from 'uuid';
import CircularProgress from '@material-ui/core/CircularProgress';
import dotProp from 'dot-prop-immutable';

export default function MultiSelectList({
    filter,
    filterIndex,
    parentFilters,
    updateFilters,
    className,
    nameMapping,
    suffix,
}) {
    const updateValue = (event, choiceIndex) => {
        const {checked} = event.target;
        const newFilters = dotProp.set(parentFilters, `${filterIndex}.choices.${choiceIndex}.active`, checked);

        updateFilters(newFilters);
    };

    const updateFilter = (choiceIndex, filters) => {
        const newFilters = dotProp.set(parentFilters, `${filterIndex}.choices.${choiceIndex}.filters`, filters);

        updateFilters(newFilters);
    };

    return (
        <ul className={className}>
            {filter.choices.map((choice, choiceIndex) => {
                const id = uuidv1();
                return (
                    <li key={choiceIndex} className="list-group-item px-0 py-1">
                        <CustomCheckBox
                            id={id}
                            filter={filter}
                            choice={choice}
                            updateValue={(e) => {
                                updateValue(e, choiceIndex);
                            }}
                            nameMapping={nameMapping}
                            suffix={suffix}
                        />

                        {/* Level Deeper */}
                        {choice.filters.length > 0 &&
                            choice.active &&
                            choice.filters.map((filter, filterIndex) => {
                                if (typeof filter.choices.length !== 'undefined' && filter.choices.length > 0) {
                                    return (
                                        <MultiSelectList
                                            className="list-group list-group-flush pl-5"
                                            parentFilters={choice.filters}
                                            filter={filter}
                                            filterIndex={filterIndex}
                                            updateFilters={(filters) => {
                                                updateFilter(choiceIndex, filters);
                                            }}
                                            key={filterIndex}
                                        />
                                    );
                                }
                            })}
                    </li>
                );
            })}
        </ul>
    );
}

const CustomCheckBox = ({id, filter, choice, updateValue, nameMapping, suffix}) => {
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        setIsUpdating(false);
    }, [choice.active]);

    const onChange = (event) => {
        setIsUpdating(true);
        updateValue(event);
    };

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
        <div className={`custom-control custom-checkbox position-relative`}>
            {isUpdating && (
                <div className="custom-control__loading">
                    <CircularProgress classes={{root: 'loading loading--circular-progress'}} />
                </div>
            )}
            <input
                id={id}
                name={`${filter.filterKey}[]`}
                className="custom-control-input"
                type="checkbox"
                value={choice.name}
                checked={choice.active}
                onChange={onChange}
            />

            <label className="custom-control-label" htmlFor={id}>
                <div className="d-flex gap-1 align-items-center">
                    <span className={!choice.active ? 'text-muted--60': ''}>
                        {nameMapping ? nameMapping[choice.name] : choice.name ? capitalizeFirstLetter(choice.name) : ''}
                    </span>
                    {suffix ? suffix : ''}
                </div>
                {choice.count > 0 && <span className="filter-count">{choice.count}</span>}
            </label>
        </div>
    );
};
